import type { IconProps } from './Icon.types';

export const iconDefaults: Partial<IconProps> & { varPrefix: string } = {
  iconColor: 'var:primary',
  varPrefix: 'ti-',
  size: 'md',
};
